/* tslint:disable:typedef */

import autoBind from 'auto-bind'
// import {Handler, any} from 'express';

/**
 * BaseClass for Router files in REST APIs
 *
 * @class
 * @classdesc BaseClass for Router files in REST APIs
 */
export abstract class BaseRouter {
  public static errJson(res: any, code: number = 200, message: string): any {
    return res.status(code).json({ message })
  }

  constructor() {
    autoBind(this)
  }

  /**
   * @param {Object} app - app context
   */
  // constructor(app: any) {
  //   this.app = app;
  // }

  public mapRoutes(): void {
    throw new Error(`${this.constructor.name}.mapRoutes is not implemented`)
  }

  public catchErr(handler): any {
    return (req, res, next) => {
      Promise.resolve(handler.call(this, req, res, next)).catch(err => {
        res.status(500).json({ msg: err.message })

        // next(err);
      })
    }
  }

  public errOk<K>(res: any, dto?: K): any {
    if (dto !== null || dto !== undefined) {
      res.type('application/json')
      return res.status(200).json(dto)
    } else {
      return res.sendStatus(200)
    }
  }

  public created(res: any) {
    return res.sendStatus(201)
  }

  public errBadRequest(res: any, message?: string) {
    return BaseRouter.errJson(res, 400, message ? message : 'Bad Request')
  }

  public errUnauthorized(res: any, message?: string) {
    return BaseRouter.errJson(res, 401, message ? message : 'Unauthorized')
  }

  public errPaymentRequired(res: any, message?: string) {
    return BaseRouter.errJson(res, 402, message ? message : 'Payment required')
  }

  public errForbidden(res: any, message?: string) {
    return BaseRouter.errJson(res, 403, message ? message : 'Forbidden')
  }

  public errNotFound(res: any, message?: string) {
    return BaseRouter.errJson(res, 404, message ? message : 'Not found')
  }

  public errConflict(res: any, message?: string) {
    return BaseRouter.errJson(res, 409, message ? message : 'Conflict')
  }

  public errTooMany(res: any, message?: string) {
    return BaseRouter.errJson(res, 429, message ? message : 'Too many requests')
  }

  public errNotImplemented(res: any, message?: string) {
    return BaseRouter.errJson(res, 501, message ? message : 'Not Implemented')
  }

  public todo(res: any) {
    return BaseRouter.errJson(res, 400, 'TODO')
  }

  public errFailed(res: any, error: Error | string) {
    return res.status(500).json({
      message: error.toString()
    })
  }
}
